export enum HABIT_QUESTIONS {
  HABIT_SURVEY_ID = '1a6e2ced-d9fc-422d-92ad-2952374cecbe',
  GOAL_SURVEY_ID = 'e478899a-9b82-4d88-8b26-061d1b0ff26a',
  HEALTHY_EATING = 'af07bbac-7ec1-4217-92e0-85a840086ba9',
  TAKE_MEDICATIONS = 'cd21c075-6926-4fca-90cd-f52a811f483e',
  MONITOR_DISEASE = 'e7b2ca06-26ca-4c25-b712-d5814a5d0ce2',
  ACTIVE = 'bc49bb15-3620-4bc6-a7cc-8373f19e3a58',
  STRESS_LEVEL = 'c5631273-4fe1-43f1-a555-235a928dee16',
  HYP_ATTACKS = 'd481efdd-f0bf-4715-a666-77cb3315f5f7',
  LOW_SODIUM = '6e41d4f2-abdc-4f77-8769-596500cb1433',
  EXERCISE = '4bfc2693-6f11-4fb8-9263-6ede2cce0405',
  EXERCISE_DURATION = '365ad762-d858-4a4f-8cca-5a364f260d78',
}
